import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const SecurityMeasureSchema = BigdesDefinitionSchema.extend({
    measureType: z.string().optional(), // technical, administrative
});
export const CreateSecurityMeasureSchema = SecurityMeasureSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateSecurityMeasureSchema = SecurityMeasureSchema.partial();
